export var defaultSpacerState = {
    height: 24,
};
//# sourceMappingURL=state.js.map